import React from "react";
import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { FaCircleCheck } from 'react-icons/fa6'
import { useModal } from "../../../../hooks/ModalContext";
import { useNavigate } from "react-router-dom";

interface ModalSucessoProps {
  message?: string;
  img?: string;
}

export const ModalSucesso = ({ message, img }: ModalSucessoProps) => {
  const { onClose, openSucessoModal } = useModal()
  const navigate = useNavigate()
  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    }
  }

  function closeModal() {
    if (openSucessoModal.title === 'Senha alterada com sucesso!') {
      onClose(true)
      navigate('/')
    } else {
      onClose(true)
    }
  }
  return (
    <>
      <Modal
        show={openSucessoModal.isOpen}
        // show={true}
        popup={true}
        size={"md"}
        onClick={() => closeModal()}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="flex items-center justify-center flex-col p-6">
            {img ? <img src={img} alt="" /> : <FaCircleCheck className="fill-green-600 m-4" size={70} />}
            <p className="font-medium text-center text-lg m-2 text-gray-800 w-full">{message ? message : openSucessoModal.title}</p>
            {/* <button type="button" className="bg-primary text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => onClose(true)}>Fechar</button> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}